"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var Checkbox_1 = __importDefault(require("@material-ui/core/Checkbox"));
var FormControlLabel_1 = __importDefault(require("@material-ui/core/FormControlLabel"));
var classnames_1 = __importDefault(require("classnames"));
var useStyles_1 = __importDefault(require("./useStyles"));
var Checkbox = function (_a) {
    var _b, _c, _d;
    var classes = _a.classes, isChecked = _a.isChecked, checkedIcon = _a.checkedIcon, _e = _a.color, color = _e === void 0 ? 'primary' : _e, disabled = _a.disabled, disableRipple = _a.disableRipple, icon = _a.icon, id = _a.id, _f = _a.indeterminate, indeterminate = _f === void 0 ? false : _f, indeterminateIcon = _a.indeterminateIcon, inputProps = _a.inputProps, inputRef = _a.inputRef, onChange = _a.onChange, required = _a.required, _g = _a.size, size = _g === void 0 ? 'medium' : _g, value = _a.value, name = _a.name, _h = _a.labelPlacement, labelPlacement = _h === void 0 ? 'end' : _h, _j = _a.label, label = _j === void 0 ? '' : _j, _k = _a.fullWidth, fullWidth = _k === void 0 ? false : _k, checkboxPadding = _a.checkboxPadding;
    var internalClasses = (0, useStyles_1.default)({
        labelPlacement: labelPlacement,
        label: label,
        fullWidth: fullWidth,
        checkboxPadding: checkboxPadding
    });
    var _l = classes || {}, _m = _l.formControlLabel, formControlLabelClasses = _m === void 0 ? {} : _m, _o = _l.checkbox, checkboxClasses = _o === void 0 ? {} : _o;
    return (react_1.default.createElement(FormControlLabel_1.default, { labelPlacement: labelPlacement, classes: __assign(__assign({}, formControlLabelClasses), { root: (0, classnames_1.default)((_b = {},
                _b[internalClasses.labelRoot] = true,
                _b[formControlLabelClasses.root || ''] = true,
                _b)), label: (0, classnames_1.default)((_c = {},
                _c[internalClasses.label] = true,
                _c[formControlLabelClasses.label || ''] = true,
                _c)) }), label: label, control: react_1.default.createElement(Checkbox_1.default, { classes: __assign(__assign({}, checkboxClasses), { root: (0, classnames_1.default)((_d = {},
                    _d[internalClasses.checkboxRoot] = true,
                    _d[checkboxClasses.root || ''] = true,
                    _d)) }), checkedIcon: checkedIcon, color: color, disabled: disabled, disableRipple: disableRipple, icon: icon, id: id, indeterminate: indeterminate, indeterminateIcon: indeterminateIcon, inputProps: inputProps, inputRef: inputRef, required: required, size: size, value: value, name: name, checked: isChecked, onPointerDown: function (event) {
                if (event.isTrusted && onChange) {
                    // @ts-ignore
                    onChange(event, !event.target.checked);
                }
            } }) }));
};
exports.default = Checkbox;
